import {UPDATE_MIGRATIONS_LIST, SHOW_ALL_THEMIS_MIGRATIONS, SHOW_ALL_CPPRO_MIGRATIONS, SHOW_ALL_SPREADSHEET_MIGRATIONS} from '../../action.types'

export const updateMigrationsList = migrationsList => ({type: UPDATE_MIGRATIONS_LIST, payload: migrationsList})

export const showAllThemisMigrations = () => ({type: SHOW_ALL_THEMIS_MIGRATIONS})

export const showAllCpproMigrations = () => ({type: SHOW_ALL_CPPRO_MIGRATIONS})

export const showAllSpreadsheetMigrations = () => ({type: SHOW_ALL_SPREADSHEET_MIGRATIONS})


// WEBPACK FOOTER //
// ./src/js/actions/migrations-list/migrations.list.actions.js